export const carEquipmentLabel = 'Wyposażenie';
export const carTechnicalInfoLabel = 'Dane';
export const carTechnicalInfoLabelHighlighted = 'techniczne';
export const backButton = 'POWRÓT DO WYSZUKIWANIA';
export const financeLabel = 'Finansowanie';
export const financeLabelHighlighted = 'Dacia';
